export default async function isLoggedInUser() {
  if (localStorage && localStorage.getItem("credentials")) {
    return true;
  }
  return false;
}
